import CustomQueryClientProvider from 'typescript/providers/custom_query_client_provider';

// For now this is just a wrapper for the CustomQueryClientProvider, but in the future we can add more providers here
export const TestProviderWrapper = ({ children }) => {
  return <CustomQueryClientProvider>{children}</CustomQueryClientProvider>;
};
